export const weddingDashboardEditorialWithNoDekOptimizelyConfig = {
  // The variation represenst the Original Onboard Flow, so if it is found, show the original onboard flow.
  // Staging
  554664308: {
    pageName: '554664308_url_targeting_for_wedding_dashboard_editorial_no_dek',
    experimentId: '13645020554',
    variationId: '13654680665'
  },
  // Production
  566520915: {
    pageName: '566520915_url_targeting_for_wedding_dashboard_editorial_no_dek',
    experimentId: '13662300568',
    variationId: '13652700571'
  }
};

// Variation A - Invites Redirect publish flow
export const testPublishWebsiteInviteRedirectVariationA = {
  554664308: {
    pageName: 'web_actions_for_manage_cms_designs_pages',
    experimentId: '13640090411',
    variationId: '13670740198'
  },
  // Production
  566520915: {
    pageName: 'web_actions_for_manage_cms_designs_pages',
    experimentId: '13848220237',
    variationId: '13831080255'
  }
};

// Variation B - Invites Redirect publish flow
export const testPublishWebsiteInviteRedirectVariationB = {
  // staging
  554664308: {
    pageName: 'web_actions_for_manage_cms_designs_pages',
    experimentId: '13640090411',
    variationId: '13680310582'
  },
  // Production
  566520915: {
    pageName: 'web_actions_for_manage_cms_designs_pages',
    experimentId: '13848220237',
    variationId: '13841010402'
  }
};

export const fastFacetsDesktopOptimizelyTest = {
  // Staging
  554664308: {
    pageName: '554664308_url_targeting_for_fast_facets_test_desktop',
    experimentId: '14896670642',
    variationId: '14921090486'
  },
  // Production
  566520915: {
    pageName: '566520915_url_targeting_for_fast_facets_test_desktop',
    experimentId: '14923090463',
    variationId: '14882620624'
  }
};

export const fastFacetsMobileOptimizelyTest = {
  // Staging
  554664308: {
    pageName: '554664308_url_targeting_for_fast_facets_test_mobile_web',
    experimentId: '14894800524',
    variationId: '14911210472'
  },
  // Production
  566520915: {
    pageName: '566520915_url_targeting_for_fast_facets_test_mobile_web',
    experimentId: '14913070735',
    variationId: '14919080585'
  }
};

// Extended Website Onboarding - 3rd try ;)
export const extendedWebsiteOnboardOptimizelyConfig3 = {
  // Staging
  554664308: {
    pageName: '554664308_url_targeting_for_extended_website_onboarding_3',
    experimentId: '16840231376',
    variationId: '16851841507'
  },
  // Production
  566520915: {
    pageName: '566520915_url_targeting_for_extended_website_onboarding_3',
    experimentId: '16830532110',
    variationId: '16840752396'
  }
};

export const zolaStoriesConfig = {
  // Staging
  554664308: {
    pageName: '554664308_url_targeting_for_zola_stories',
    experimentId: '16848358662',
    variationId: '16865459859'
  },
  // Production
  566520915: {
    pageName: '566520915_url_targeting_for_zola_stories_1',
    experimentId: '17035080285',
    variationId: '17014260323'
  }
};

export const emptyGLOnboardingTourConfig = {
  // Staging
  554664308: {
    pageName: '554664308_url_targeting_for_empty_guest_list_onboarding_1',
    experimentId: '17225280231',
    variationId: '17188470161'
  },
  // Production
  566520915: {
    pageName: '566520915_url_targeting_for_empty_guest_list_onboarding',
    experimentId: '17217550487',
    variationId: '17194320435'
  }
};

// Variation #1: hidden secondary nav
export const planningDashboardSecondaryNavConfig = {
  // Staging
  554664308: {
    pageName: '554664308_url_targeting_for_remove_secondary_nav_from_planning_d',
    experimentId: '17202200692',
    variationId: '17190820723'
  },
  // Production
  566520915: {
    pageName: '566520915_url_targeting_for_remove_secondary_nav_from_planning_d',
    experimentId: '17200370428',
    variationId: '17219020771' 
  }
};


// WEBPACK FOOTER //
// ./src/util/optimizelyConfigs.js